export const updateWorkspace = {
    handle: 'UPDATE_WORKSPACE_HANDLE',
    customDomain: 'UPDATE_YOUR_CUSTOM_DOMAIN',
    setupCustomDomain: 'SETUP_CUSTOM_DOMAIN_FOR_WORKSPACE',
    formLinkWithPreviousDomainError: 'FORM_LINK_WITH_PREVIOUS_DOMAIN_WONT_WORK',
    addCnameRecordMessage: 'ADD_CNAME_RECORD_MESSAGE',
    formLinkWithPreviousworkspaceHandleError: 'FORM_LINK_WITH_PREVIOUS_WORKSPACE_HANDLE_WONT_WORK',
    invalidDomain: 'INVALID_DOMAIN',
    invalidWorkspaceHandle: 'INVALID_WORKSPACE_HANDLE',
    common: {
        consequence: 'UPDATE_WORKSPACE.COMMON.CONSEQUENCE',
        currentLink: 'UPDATE_WORKSPACE.COMMON.CURRENT_LINK',
        change: 'UPDATE_WORKSPACE.COMMON.CHANGE'
    },
    handles: {
        desc: 'UPDATE_WORKSPACE.HANDLE.DESC',
        point1: 'UPDATE_WORKSPACE.HANDLE.POINT_1',
        point2: 'UPDATE_WORKSPACE.HANDLE.POINT_2'
    },
    domain: {
        desc: 'UPDATE_WORKSPACE.DOMAIN.DESC',
        point1: 'UPDATE_WORKSPACE.DOMAIN.POINT_1',
        point2: 'UPDATE_WORKSPACE.DOMAIN.POINT_2'
    },
    settings: {
        common: {
            point1: 'UPDATE_WORKSPACE.SETTINGS.COMMON.POINT1',
            point2: 'UPDATE_WORKSPACE.SETTINGS.COMMON.POINT2',
            point3: 'UPDATE_WORKSPACE.SETTINGS.COMMON.POINT3'
        },
        handle: {
            point4: 'UPDATE_WORKSPACE.SETTINGS.HANDLE.POINT4'
        },
        domain: {
            remove: 'UPDATE_WORKSPACE.SETTINGS.DOMAIN.REMOVE',
            reset: 'UPDATE_WORKSPACE.SETTINGS.DOMAIN.RESET',
            cname: 'UPDATE_WORKSPACE.SETTINGS.DOMAIN.CNAME',
            confirmationTitle: 'UPDATE_WORKSPACE.SETTINGS.DOMAIN.CONFIRMATION_TITLE',
            confirmationDesc: 'UPDATE_WORKSPACE.SETTINGS.DOMAIN.CONFIRMATION_DESC'
        }
    }
};
